import React from 'react';

import _ from 'lodash';
import { FormControl, FormHelperText, Input } from '@material-ui/core';
import { InputLabel, Select as MuiSelect } from '@material-ui/core';

const Select = props => {
  const { name, value, error, helperText, required, fullWidth, disabled } = props;
  const readOnly = _.get(props, 'inputProps.readOnly');

  return (
    <FormControl
      required={required}
      fullWidth={fullWidth}
      error={error}
      classes={{ root: props.className }}
      disabled={disabled}
      style={readOnly ? { pointerEvents: 'none' } : undefined}
    >
      <InputLabel htmlFor={name}>{props.label || ''}</InputLabel>

      <MuiSelect
        value={value}
        onChange={props.onChange}
        onBlur={props.onBlur}
        input={<Input id={name} name={name} required={required} />}
        renderValue={props.renderValue}
        inputProps={_.merge(
          props.inputProps,
          readOnly ? { IconComponent: () => null } : null
        )}
      >
        {props.children}
      </MuiSelect>

      <FormHelperText error>{error && helperText ? helperText : ' '}</FormHelperText>
    </FormControl>
  );
};

export default Select;
